import React, { CSSProperties, ButtonHTMLAttributes } from 'react'
import './ButtonComponent.scss'

export type ButtonComponentVariants =
'primary' |
'secondary' |
'accent' |
'primary-violet' |
'tertiary' |
'clean' |
'secondary-outline' |
'menu-item'

export interface ButtonComponentProps extends CSSProperties {
    id?: string
    children?: any
    className?: string
    style?: CSSProperties
    disabled?: boolean
    variant?: ButtonComponentVariants
    loading?: boolean
    iconColor?: string
    type?: ButtonHTMLAttributes<HTMLButtonElement>['type']
    active?: boolean
    onClick?: ()=>void
}

interface IIconButtonComponentProps{
    children?: any
}

interface ISubComponentsButton{
    Icon: React.FC<IIconButtonComponentProps>
}

const ButtonComponent: React.SFC<ButtonComponentProps> & ISubComponentsButton = ({
  children,
  className,
  disabled,
  iconColor,
  id,
  loading,
  onClick,
  style,
  type,
  variant = 'clean',
  active,
  ...overrideStyles
}) => {

    const getClassFromVariant = () => {
        if(!variant) return ''
        return `button-component--${variant}`
    }

    return (
        <button
            className={`button-component--default ${getClassFromVariant()} ${active ? 'button-component--active' : ''} ${className ? className : ''}`}
            onClick={onClick}
            style={{...style, ...overrideStyles}}
            disabled={disabled || loading}
            type={type}
            id={id}
        >
            {loading && (
              <div className="spinner-border button-component--spinner-loading" role="status"></div>
            )}
            {children}
        </button>
    );
}

const Icon: React.FC<IIconButtonComponentProps> = ({ children }) => {
    return(
        <div className="button-component--container-icon-button">
            {children}
        </div>
    )
}

ButtonComponent.Icon = Icon

export default ButtonComponent;
